import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Input,
  Container,
  Button,
  Segment,
  Table,
  Grid,
  Loader,
  Icon
} from 'semantic-ui-react'


import titleCase from 'title-case'

import './Teachers.css'
import PaginationTable from '../../components/PaginationTable/PaginationTable'
import TeachersReadCSV from './TeachersReadCSV'
import TeachersExport from './TeachersExport'
import TeachersAdd from './TeachersAdd'
import TeachersEdit from './TeachersEdit'
import TeachersDelete from './TeachersDelete'

const changeCase = {
    titleCase: titleCase
}

const TeachersPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar') {
    const { activePage, itemPerPage, column, direction, data, searchKey, fields, loaded } = props;
    let currentData = data.filter(props.isSearched(searchKey));
    const indexOfLast = activePage * itemPerPage;
    const indexOfFirst = indexOfLast - itemPerPage;
    const rowLength = currentData.length;
    currentData = currentData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(rowLength / itemPerPage);

    const teacherTable = currentData.map((teacher, key )=> {
      return (
        <Table.Row key={key} className='teachers-table-row'>
          <Table.Cell>{teacher.lastName}</Table.Cell>
          <Table.Cell>{teacher.firstName}</Table.Cell>
          <Table.Cell>{teacher.username}</Table.Cell>
          <Table.Cell>{changeCase.titleCase(teacher.type)}</Table.Cell>
          <Table.Cell collapsing>
            <Button icon size='tiny' onClick={() => props.handleRowClick(teacher)}>
              <Icon name='eye' />
            </Button>
            <TeachersEdit
              teacher={teacher}
              handleUpdate={props.handleUpdate}
            />

            <TeachersDelete
              teacherId={teacher.teacherId}
              teacherName={`${teacher.firstName} ${teacher.lastName}`}
              handleDelete={props.handleDelete}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    let headers = fields.map((field,index) => {
      return (
        <Table.HeaderCell
          key={index}
          sorted={column === field ? direction : null}
          onClick={() => props.handleSort(field)}
          textAlign='center'
        >
          {changeCase.titleCase(field)}
        </Table.HeaderCell>
      )
    });

    return (
      <div>
        <Container>
          <Segment>
            <Grid>
              <Grid.Column floated='left' width={6}>
                <Grid.Column width={4}>
                  <Input
                    icon='search'
                    value={searchKey}
                    onChange={props.onSearchChange}
                    placeholder='Search Teachers'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column floated='right' width={10}>
                <Grid.Column floated='right' width={10}>

                  <Button.Group floated='right'>
                    <TeachersReadCSV
                      handleFileChange={props.handleFileChange}
                      handleDataSave={props.handleDataSave}
                    />
                    <Button.Or />
                    <TeachersAdd
                      handleSubmit={props.handleSubmit}
                    />
                  </Button.Group>
                  {
                    data.length > 0 ?
                    <TeachersExport data={data} /> :
                    null
                  }

              </Grid.Column>

              </Grid.Column>
            </Grid>
            {
              loaded ?
              <div className='table-teachers'>
                {
                  data.length > 0 ?
                  <Table celled selectable sortable striped size='small'>
                    <Table.Header>
                      <Table.Row>
                        {headers}
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>{teacherTable}</Table.Body>
                      {
                        data.length > itemPerPage ?
                        <PaginationTable
                          onPageChange={props.handlePaginationChange}
                          totalPages={totalPages}
                          activePage={activePage}
                          fields={fields}
                        >

                        </PaginationTable>
                        :
                        null
                      }
                  </Table>
                  :
                  <Segment>No teacher records found.</Segment>
                }
              </div>
              :
              <Loader active inline='centered' />
            }

          </Segment>
        </Container>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default TeachersPV;
